import React, { useEffect, useState } from 'react';
import { Typography, TextField, Skeleton, Box, FormLabel, FormControl } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { useObjectContext } from '@/hooks/useObjectContext';
import { minimalInputTheme } from '@/app/theme';
import { useUpdateClientRowMutation } from '@/features/clients/clientsApi';

export const ProspectAmountValue = ({ hideLabel = false }) => {
	const { clientRow, clientId } = useObjectContext();
	const [prospectAmountValue, setProspectAmountValue] = useState(clientRow?.prospectAmount ?? 0);

	useEffect(() => {
		setProspectAmountValue(clientRow?.prospectAmount ?? 0);
	}, [clientRow?.prospectAmount]);

	// Use useUpdateClientRowMutation instead
	const [updateClientRow, { isLoading: isUpdatingClient }] = useUpdateClientRowMutation();

	const updateProspectAmount = async () => {
		// Only update if value changed
		if (prospectAmountValue === (clientRow?.prospectAmount ?? 0)) {
			return;
		}

		await updateClientRow({
			clientId: clientId,
			docId: clientRow?.docId,
			properties: {
				prospectAmount: prospectAmountValue,
			},
		}).unwrap();
	};

	return (
		<FormControl fullWidth>
			{!hideLabel && <FormLabel>Prospect Amount</FormLabel>}
			{isUpdatingClient ? (
				<Skeleton animation='wave' width='55%' height='2em' />
			) : (
				<NumericFormat
					fullWidth
					disabled={isUpdatingClient}
					customInput={TextField}
					thousandSeparator
					decimalScale={0}
					fixedDecimalScale
					allowNegative={false}
					prefix='$'
					variant='standard'
					sx={minimalInputTheme}
					className='minimal-input'
					value={prospectAmountValue}
					onValueChange={({ floatValue }) => setProspectAmountValue(floatValue || 0)}
					onBlur={updateProspectAmount}
				/>
			)}
		</FormControl>
	);
};
